import React from 'react';
import SectorPage from '../SectorPage/SectorPage';

const ServicesFinanciers = () => {
  const sectorData = {
    title: "Services Financiers",
    subtitle: "Accélérez votre prospection B2B",
    intro: "Banques d'affaires, gestionnaires de patrimoine ou cabinets en optimisation fiscale : les services financiers B2B doivent s'adresser à des dirigeants, DAF ou investisseurs avec rigueur et pédagogie. Créer la confiance via des contenus réglementaires, des simulateurs financiers ou des prises de parole expertes est devenu incontournable pour nourrir la prospection commerciale.",
    name: "Services Financiers",
    titleContext: "des services financiers",
    responseContext: "des Services Financiers",
    expertContext: "des Services Financiers"
  };

  return <SectorPage sector={sectorData} />;
};

export default ServicesFinanciers; 